module.exports = __webpack_public_path__ + "img/tanom_banner_green.ff942b2a.png";